
import DialogTable from '@/components/DialogTable.vue';
import BackendResourceDataTable from '@/components/BackendResourceDataTable.vue';
import { mainStore, ordemCarregamentoStore, userToolStore } from '@/store';
import _ from 'lodash';
import Vue from 'vue';
import Component from 'vue-class-component';
import api from '@/api';
import { IOrdemCarregamento } from '@/interfaces/ordemCarregamento';
import { format } from 'date-fns';

@Component({
  components: { BackendResourceDataTable, DialogTable },
})
export default class ListImpressao extends Vue {
  showImpressos = false;
  isLoading = false;
  isItemLoading: any = null;

  nfsDownloading = [];

  async downloadNf({ t016_numero_documento, franchising_id }) {
    this.nfsDownloading.push(t016_numero_documento);
    const response = await api.getNfByNumeroNota(mainStore.token, t016_numero_documento, franchising_id);

    if (response && response.status === 200) {
      const { data } = response;
      const blob = new Blob([data]);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${t016_numero_documento}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
    this.nfsDownloading = [];
  }

  get impressaoTool() {
    return (
      _.find(userToolStore.currentUserTools, { tool_id: 89 }) || {
        allow_view: false,
        allow_edit: false,
        allow_delete: false,
        allow_create: false,
      }
    );
  }

  printQrCodes(fileName: string, base64String: string) {
    const binaryData = atob(base64String);
    const uint8Array = new Uint8Array(binaryData.length);
    for (let i = 0; i < binaryData.length; i++) {
      uint8Array[i] = binaryData.charCodeAt(i);
    }
    const blob = new Blob([uint8Array], { type: 'application/pdf' });

    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = `${fileName}-qrcodes.pdf`;

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    return;
  }

  printZipQrCodes(fileName: string, base64String: string) {
    const binaryData = atob(base64String);
    const uint8Array = new Uint8Array(binaryData.length);
    for (let i = 0; i < binaryData.length; i++) {
      uint8Array[i] = binaryData.charCodeAt(i);
    }
    const blob = new Blob([uint8Array], { type: 'application/zip' });

    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = `${fileName}-qrcodes.zip`;

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    return;
  }

  async geEtiquetas(ordensCarregamento: IOrdemCarregamento[]) {
    const t016_numero_documentos = _.map(ordensCarregamento, 't016_numero_documento');
    const { error, content } = await ordemCarregamentoStore.getOrdemCarregamentoImpressaoQRCodes({
      t016NumeroDocumentos: t016_numero_documentos,
    });

    if (!error) {
      if (t016_numero_documentos.length === 1) {
        this.printQrCodes(t016_numero_documentos[0], content);
      } else if (t016_numero_documentos.length > 1) {
        this.printZipQrCodes(format(new Date(), 'dd-MM-yyyy_HH-MM-SS'), content);
      }
    } else {
      this.$swal({
        icon: 'error',
        title: 'Erro',
        text: content,
      });
    }
  }

  async getEtiqueta({ t016_numero_documento, impresso_por }) {
    let print = true;
    if (this.isItemLoading) return;

    if (impresso_por) {
      await this.$swal({
        icon: 'warning',
        title: 'Atenção!',
        html: `
          As Etiquetas para esta NF já foram impressas por ${impresso_por.full_name}<br/>
          Deseja imprimí-los novamente?
        `,
        showCancelButton: true,
      }).then((result) => {
        if (!result.isConfirmed) {
          print = false;
        }
      });
    }

    if (!print) return;

    this.isItemLoading = t016_numero_documento;

    const { error, content } = await ordemCarregamentoStore.getOrdemCarregamentoImpressaoQRCodes({
      t016NumeroDocumentos: [t016_numero_documento],
    });

    this.isItemLoading = false;

    if (error) {
      this.$swal({
        icon: 'error',
        title: 'Erro ao gerar QR Codes',
        text: content,
      });
      return;
    }
    this.printQrCodes(t016_numero_documento, content);
  }

  getTypePreInvoices(pre_invoices) {
    if (pre_invoices.length <= 0) return '-';

    if (!pre_invoices[0]['invoice_aluno_id']) {
      return 'PJ';
    } else {
      return 'PF';
    }
  }
}
